import { render, staticRenderFns } from "./BSSignContract.vue?vue&type=template&id=15531dae"
import script from "./BSSignContract.vue?vue&type=script&lang=js"
export * from "./BSSignContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports